import { defineSlotRecipe } from '@chakra-ui/react/styled-system';

import { rem } from '../themeUtils';

const ribbonSlotRecipe = defineSlotRecipe({
  className: 'ribbon',
  slots: ['root', 'content', 'textBlock', 'closeButton'],
  base: {
    root: {
      // Below tablet everything stacks, so the close button rides at the top of the block
      // instead of being centred against it.
      alignItems: { base: 'flex-start', tablet: 'center' },
      borderBlockStyle: 'solid',
      borderBlockWidth: '1',
      display: 'flex',
      // On desktop the close button sits flush after the content and relies on its own
      // 8px icon inset; stacked, the wrapped text needs real space before it.
      gap: { base: '12', tablet: 0 },
      paddingBlock: '12',
      paddingInline: { base: '16', tablet: '24' },
      width: 'full',
    },
    content: {
      // `flex-start` rather than `stretch`: the text block opts back into full width below,
      // while the action button keeps its intrinsic width instead of spanning the ribbon.
      alignItems: { base: 'flex-start', tablet: 'center' },
      display: 'flex',
      flex: '1 0 0',
      flexDirection: { base: 'column', tablet: 'row' },
      gap: { base: '12', tablet: '16' },
      justifyContent: 'center',
      minHeight: '32',
      minWidth: 0,
    },
    textBlock: {
      alignItems: { base: 'flex-start', tablet: 'baseline' },
      display: 'flex',
      // Below tablet title, message and link each get their own line. As a row they would
      // shrink into narrow side-by-side columns instead of wrapping.
      flexDirection: { base: 'column', tablet: 'row' },
      gap: '4',
      minWidth: 0,
      textStyle: 'body/md/regular',
      width: { base: 'full', tablet: 'auto' },
    },
    closeButton: {
      flexShrink: 0,
      // Stacked, Figma leaves 12px to the right of the close button while the text keeps the
      // root's 16px inline padding. The bleed buys back those 4px without moving the content.
      marginInlineEnd: { base: rem(-4), tablet: 0 },
    },
  },
  variants: {
    colorVariant: {
      blue: { root: { background: 'color/blue/subtle', borderColor: 'color/blue/muted', color: 'color/blue/strong' } },
      green: {
        root: { background: 'color/green/subtle', borderColor: 'color/green/muted', color: 'color/green/strong' },
      },
      yellow: {
        root: { background: 'color/yellow/minimal', borderColor: 'color/yellow/muted', color: 'color/yellow/strong' },
      },
      red: { root: { background: 'color/red/subtle', borderColor: 'color/red/muted', color: 'color/red/strong' } },
      purple: {
        root: { background: 'color/purple/subtle', borderColor: 'color/purple/muted', color: 'color/purple/strong' },
      },
    },
  },
  defaultVariants: {
    colorVariant: 'blue',
  },
});

export default ribbonSlotRecipe;
